import type { Types } from '@fiverr-private/theme';

export const DIALOG_WIDTH: Types.ResponsiveWidthType = {
    sm: 520,
    md: 600,
    lg: 720,
    xl: 900,
};
